module.exports = __webpack_public_path__ + "img/avatar.1eb28d8a.svg";